import { c as _c } from "react/compiler-runtime";
import { BLOGS_API } from 'modules/blogs/api/blog-api';
import { UseBlogTemplateInterface } from 'modules/blogs/types/blog-template-interface';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export function useBlogTemplate() {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (user) {
        return [`${BLOGS_API}/templates`, user.dashboardLocale];
      }
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSWR(t0, _temp);
}
function _temp(t0) {
  const [url] = t0;
  return baseFetcher(url);
}